export const numberFormat = (num: number, decimalPlaces = 0, prefix = '', suffix = '') => {
  const numToDisplay =
    num > 999
      ? num?.toFixed(decimalPlaces).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      : num?.toFixed(decimalPlaces);

  return prefix + numToDisplay + suffix;
};
